<template>
  <div>
    <!-- Custom Input (Bootstrap Vue or Native) -->
    <b-form-input
      v-model="query"
      placeholder="Sugerencias para autocompletar"
      ref="autocompleteInput"
      @input="fetchAutocompleteResults"
      @keydown.down="highlightNext"
      @keydown.up="highlightPrev"
      @keydown.enter.prevent="selectHighlighted"
    ></b-form-input>

    <!-- Autocomplete Suggestions -->
    <ul v-if="suggestions.length" class="autocomplete-suggestions">
      <li
        v-for="(suggestion, index) in suggestions"
        :key="index"
        @click="selectSuggestion(suggestion)"
        :class="{ highlighted: index === highlightedIndex }"
      >
        {{ suggestion.description }}
      </li>
    </ul>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';

export default {
  name: 'GoogleAutocomplete',
  data() {
    return {
      query: '',
      suggestions: [],
      autocompleteService: null,
      highlightedIndex: -1,
    };
  },
  async mounted() {
    await this.loadGoogleMaps();
  },
  methods: {
    async loadGoogleMaps() {
      const loader = new Loader({
        apiKey: 'AIzaSyDWfH_eLpCpVB6e7_c0gppQCgkzNlg5B_Y',
        version: 'weekly',
        libraries: ['places'],
      });

      const google = await loader.importLibrary('places');
      this.autocompleteService = new google.AutocompleteService();
    },

    async fetchAutocompleteResults() {
      if (!this.query || !this.autocompleteService) return;

      this.autocompleteService.getPlacePredictions(
        {
          input: this.query,
          types: ['geocode'],
          language: 'es',
        },
        (predictions, status) => {
          if (status === 'OK' && predictions) {
            this.suggestions = predictions;
          } else {
            this.suggestions = [];
          }
        }
      );
    },

    async selectSuggestion(suggestion) {
      this.query = suggestion.description;
      this.suggestions = [];

      // Fetch full place details
      const placeDetails = await this.getPlaceDetails(suggestion.place_id);
      this.$emit('address-selected', placeDetails);
    },

    async getPlaceDetails(placeId) {
      return new Promise((resolve) => {
        const service = new google.maps.places.PlacesService(
          document.createElement('div')
        );
        service.getDetails({ placeId }, (place, status) => {
          if (status === 'OK') {
            resolve({
              street_number: this.getAddressComponent(place, 'street_number'),
              route: this.getAddressComponent(place, 'route'),
              city: this.getAddressComponent(place, 'locality'),
              region: this.getAddressComponent(
                place,
                'administrative_area_level_1'
              ),
              country: this.getAddressComponent(place, 'country'),
              postal_code: this.getAddressComponent(place, 'postal_code'),
              province: this.getAddressComponent(
                place,
                'administrative_area_level_2'
              ),
            });
          } else {
            resolve({});
          }
        });
      });
    },

    getAddressComponent(place, type) {
      if (!place.address_components) return {};

      const component = place.address_components.find((comp) =>
        comp.types.includes(type)
      );
      if (type === 'country') {
        // Return ISO2 country code
        const countryComponent = component ? component.short_name : '';
        return countryComponent;
      }
      return component ? component.long_name : '';
    },

    // Handle keyboard navigation
    highlightNext() {
      if (this.highlightedIndex < this.suggestions.length - 1) {
        this.highlightedIndex++;
      }
    },
    highlightPrev() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      }
    },
    selectHighlighted() {
      if (this.highlightedIndex >= 0) {
        this.selectSuggestion(this.suggestions[this.highlightedIndex]);
      }
    },
  },
};
</script>

<style scoped>
.autocomplete-suggestions {
  list-style: none;
  padding: 0;
  margin: 5px 0;
  border: 1px solid #ddd;
  background: white;
  position: absolute;
  z-index: 1000;
  width: 100%;
}
.autocomplete-suggestions li {
  padding: 8px;
  cursor: pointer;
}
.autocomplete-suggestions li.highlighted {
  background: #ddd;
}
</style>
